$(document).ready(function(){
    $('.addToCart').on('click', function(e){
        e.preventDefault();
        $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            data:$('#product_form').serialize(),
            dataType: 'json',            
            success: function(data) {
              get_cart_details();
              $('body').addClass('cartShown'); 
            },
            error: function(err){
                console.log('error');
            }
        });
    });

    function get_cart_details(){
        $.getJSON('/cart.js', function(cart){ 
            fetch('/?section_id=cart-drawer')
            .then(response => response.text())
            .then(cartData => {
                var cart_html = $(cartData);
                var cart_items = $('.basket-conteiner' , cart_html);
                var cart_header = $('.cart_header' , cart_html);
                $('.basket-conteiner').replaceWith(cart_items);
                $('.cart_header').replaceWith(cart_header);
            }); 
        });
    };

    setTimeout(function() {
    $.getJSON('/cart.js', function(cart) {
        var cartItems = cart.items;
        // console.log(cartItems.length);
        if( cartItems == 0) {
            $('.cart-item-wrap').html('<div class="empty-cart-content"><h3>YOUR CART IS EMPTY</h3> <div class="empty-cart-btn"><a href="/" class="btn bg-dark-blue">SHOP</a></div></div>');
        }
        });
    }, 10);  
 
});



function itemChange(e,el){  
  console.log('Event Triggered!!!')
    var variant_id= $(el).data("id");
    var qty= $(el).val();      
    var data = { updates: {} };
    data.updates[variant_id] = qty;
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(res) {  
          console.log('Data ' + res);
          
          fetch('/?section_id=main-cart')
            .then(response => response.text())
            .then(cartData => {
              console.log('CartData  , ', cartData, window.location.pathname)
                if (window.location.pathname == '/cart') {
                  window.location.reload();
                } else {
                  var cart_html = $(cartData);
                  var cart_items = $('.cart-wrap' , cart_html);
                  $('.cart-wrap').replaceWith(cart_items); 
                }
            });

            $.getJSON('/cart.js', function(cart){
                $('.header_cart_count').text(cart.item_count); 
            })
        },
        error:function(err){
            console.log('error');
        }
    });
};
// itme remove 
function itemRemove(e, el){
    e.preventDefault();
    var id = $(el).data('id');   
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
        id: parseFloat(id),
        quantity: 0,
        }
    }).then((data) => {
        $.getJSON('/cart.js', function(cart) {
            fetch('/?section_id=main-cart')
            .then(response => response.text())
            .then(cartData => {
                var cart_html = $(cartData);
                var cart_items = $('.cart-wrap' , cart_html);
                $('.cart-wrap').replaceWith(cart_items);
            });
            $('.header_cart_count').text(cart.item_count);
        });
    });
};

